const BlogData = [
  {
    id: 1,
    day: "Day 1",
    image:
      "https://cdn.pixabay.com/photo/2020/12/18/16/56/laptop-5842509_960_720.jpg",
    description: (
      <p>
        The very first day of learning Reactjs and I'm not too good at English
        so please do consider that...
        <p>
          <br />
          As of today i learned about some topics of React including: <br />
          • How to use components <br />
          • Props and Proptypes <br />
          • State and event handling <br />
        </p>
        <br />
        <p>
          And also making a TextUtils React app along with the tutorial from
          <a
            href="http://codewithharry.com"
            className="code-with-harry"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            <b>CodeWithHarry</b>
          </a>{" "}
          very thankful to him for the wonderful Reactjs Tutorial.
        </p>
      </p>
    ),
  },
  {
    id: 2,
    day: "Day 2",
    image:
      "https://cdn.pixabay.com/photo/2016/03/26/13/09/workspace-1280538_960_720.jpg",
    description: (
      <p>
        As of today i learnt more about state and event handling And added some
        logic to the TextUtils app.
        <br />
        <p>
          Topics covered: <br />
          • Ternary operator in js <br />
          • More about useState <br />
        </p>
        <br />
        <p>
          Made a Dark mode enable function in The TextUtils app being made along
          with the tutorial also learning more about bootstrap.
        </p>
      </p>
    ),
  },
  {
    id: 3,
    day: "Day 3",
    image:
      "https://cdn.pixabay.com/photo/2016/11/23/13/40/iphone-1852901_960_720.jpg",
    description: (
      <p>
        Going through tutorials and really kinda bored at some point And so i
        started working on a project in which I'll be writing my journey of
        learning Reactjs which you're ready now :)
        <br />
        <p>
          I also learned some new topics: <br />
          • Spread operator <br />
          • Map and filter methods <br />
          • React routers <br />
        </p>
        <br />
        <p>Also struggling with css :( I'm really weak in css ...</p>
      </p>
    ),
  },
  {
    id: 4,
    day: "Day 4",
    image:
      "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    description: (
      <p>
        So I've been really struggling with CSS -_- . have been working on my
        Blog website which you are reading..
        <br />
        <p>
          To be honest at some i really mess up things and don’t get what the
          shit im doing.. Maybe thats what developers go through buttt when you
          solve what you messed up thats what the thing keeps you motivated and
          i think thats what we Developers live for xD anyways.,
        </p>
        <br />
        <p>
          Also learnt new stuff about react hooks and that's all for today,, see
          yaa
        </p>
      </p>
    ),
  },
  {
    id: 5,
    day: "Day 5",
    image:
      "https://images.unsplash.com/photo-1607705703571-c5a8695f18f6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    description: (
      <p>
        <p>
          Still going through tutorials and learning more about react hooks and
          getting hands on css "(coz i'm weak)".
        </p>
        <br />
        <p>Soon I'll be introduced to class based components</p>
        <br />
        <p>
          Almost finished with my Blog project of my React journey strugging to
          make it responsive...
        </p>
      </p>
    ),
  },
  {
    id: 6,
    day: "Day 6",
    image: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    description: (
      <p>
        <p>
          Getting more into class based components and object oriented
          programming. Doing previous stuff on class based components Also about
          fetch APIs..
        </p>
        <br />
        <p>
          Anddd really thinking to Learn NextJs as it has some useful features
          like inbuilt routing and stuff to explore…
        </p>
        <br />
        <p>
          And that's all about it. <br />
          Almost finished my blog project ;) will be deploying it soon ~ <br />
          Byeee
        </p>
      </p>
    ),
  },
];

export default BlogData;
